export default __webpack_public_path__ + "static/media/brand-1.87b28ed9.png";